module.exports = __webpack_public_path__ + "static/media/recoveryPage.dbd8a5b6.md";